/********** DATATABLE **********/

export const GET_NOTARY_ORDERS_INVOICES_DT = 'GET_NOTARY_ORDERS_INVOICES_DT'
export const GET_NOTARY_ORDERS_INVOICES_DT_OK = 'GET_NOTARY_ORDERS_INVOICES_DT_OK'
export const GET_NOTARY_ORDERS_INVOICES_DT_ERR = 'GET_NOTARY_ORDERS_INVOICES_DT_ERR'
export const DO_NOTARY_ORDERS_INVOICES_DT_CLEANUP = 'DO_NOTARY_ORDERS_INVOICES_DT_CLEANUP'

/********** DATATABLE FILTERS **********/

export const APPLY_NOTARY_ORDERS_INVOICES_DT_FILTERS = 'APPLY_NOTARY_ORDERS_INVOICES_DT_FILTERS'
export const PATCH_NOTARY_ORDERS_INVOICES_DT_FILTERS = "PATCH_NOTARY_ORDERS_INVOICES_DT_FILTERS"
export const CLEAR_NOTARY_ORDERS_INVOICES_DT_FILTERS = "CLEAR_NOTARY_ORDERS_INVOICES_DT_FILTERS"
export const UNSET_NOTARY_ORDERS_INVOICES_DT_FILTERS = "UNSET_NOTARY_ORDERS_INVOICES_DT_FILTERS"